// extracted by mini-css-extract-plugin
export default {"itemsGrid":"Rent_itemsGrid__Ucs4M","itemContainer":"Rent_itemContainer__LdH9S","home":"Rent_home__uGKuY"};